import { type ReactNode } from 'react';
import { Box, Button, Text } from '@mantine/core';

type Props = {
  title: string;
  children?: ReactNode;
};

export const PropertiesHeader = ({ title, children }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Text fw={600}>{title}</Text>
      {children || <Button sx={{ opacity: 0 }}>&nbsp;</Button>}
    </Box>
  );
};
